interface UploadProgressInput {
  filesCount: number
  uploadedCount: number
  /** progress (0–100) of the file currently being uploaded */
  currentFileProgress: number
}

/** Overall upload progress across the whole queue, 0–100. */
export const getUploadProgress = ({
  filesCount,
  uploadedCount,
  currentFileProgress,
}: UploadProgressInput): number => {
  if (filesCount === 0) return 100
  return (uploadedCount / filesCount) * 100 + currentFileProgress / filesCount
}
